type IconProps = {
  className?: string;
};

const IndentRightIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-4 h-4"}
      {...rest}
    >
      <g clipPath="url(#clip0_12629_159532)">
        <path
          fill="currentColor"
          d="M2.25 3.75A.75.75 0 0 1 3 3h12a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75m0 11.25a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75m6-3.75A.75.75 0 0 1 9 10.5h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75m0-3.75A.75.75 0 0 1 9 6.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75M4.83 9.008a.488.488 0 0 1 0 .734l-1.771 1.55a.487.487 0 0 1-.809-.366V7.824c0-.418.493-.642.809-.367z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_12629_159532">
          <path fill="#fff" d="M0 0h18v18H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default IndentRightIcon;
